module.exports = __webpack_public_path__ + "assets/certificate_pdf/p_02.30320ddf.pdf";